// This file is auto-generated by @hey-api/openapi-ts
// @ts-nocheck

import * as z from 'zod/mini';

import type { Client, Options as Options2, TDataShape } from './client';
import { client } from './client.gen';
import type { DeleteApiServicesAssistantcollectionsByIdAssistantsByAssistantIdData, DeleteApiServicesAssistantcollectionsByIdAssistantsByAssistantIdErrors, DeleteApiServicesAssistantcollectionsByIdAssistantsByAssistantIdResponses, DeleteApiServicesAssistantcollectionsByIdData, DeleteApiServicesAssistantcollectionsByIdErrors, DeleteApiServicesAssistantcollectionsByIdFollowData, DeleteApiServicesAssistantcollectionsByIdFollowErrors, DeleteApiServicesAssistantcollectionsByIdFollowResponses, DeleteApiServicesAssistantcollectionsByIdResponses, DeleteApiServicesAssistantkindsByIdData, DeleteApiServicesAssistantkindsByIdErrors, DeleteApiServicesAssistantkindsByIdResponses, DeleteApiServicesAssistantsByIdData, DeleteApiServicesAssistantsByIdErrors, DeleteApiServicesAssistantsByIdResponses, GetApiAuthCapabilitiesData, GetApiAuthCapabilitiesResponses, GetApiAuthTokenData, GetApiAuthTokenErrors, GetApiAuthTokenResponses, GetApiServicesAssistantcollectionsByIdAssistantsData, GetApiServicesAssistantcollectionsByIdAssistantsErrors, GetApiServicesAssistantcollectionsByIdAssistantsResponses, GetApiServicesAssistantcollectionsByIdData, GetApiServicesAssistantcollectionsByIdErrors, GetApiServicesAssistantcollectionsByIdResponses, GetApiServicesAssistantcollectionsData, GetApiServicesAssistantcollectionsErrors, GetApiServicesAssistantcollectionsResponses, GetApiServicesAssistantkindsByIdData, GetApiServicesAssistantkindsByIdErrors, GetApiServicesAssistantkindsByIdResponses, GetApiServicesAssistantkindsData, GetApiServicesAssistantkindsResponses, GetApiServicesAssistantsByIdData, GetApiServicesAssistantsByIdErrors, GetApiServicesAssistantsByIdResponses, GetApiServicesAssistantsData, GetApiServicesAssistantsErrors, GetApiServicesAssistantsResponses, GetApiServicesChatSessionsByIdData, GetApiServicesChatSessionsByIdErrors, GetApiServicesChatSessionsByIdResponses, GetApiServicesChatSessionsData, GetApiServicesChatSessionsErrors, GetApiServicesChatSessionsResponses, PatchApiServicesAssistantcollectionsByIdData, PatchApiServicesAssistantcollectionsByIdErrors, PatchApiServicesAssistantcollectionsByIdResponses, PatchApiServicesAssistantkindsByIdData, PatchApiServicesAssistantkindsByIdErrors, PatchApiServicesAssistantkindsByIdResponses, PatchApiServicesAssistantsByIdData, PatchApiServicesAssistantsByIdErrors, PatchApiServicesAssistantsByIdResponses, PatchApiServicesChatSessionsByIdData, PatchApiServicesChatSessionsByIdErrors, PatchApiServicesChatSessionsByIdResponses, PostApiServicesAssistantcollectionsByIdAssistantsData, PostApiServicesAssistantcollectionsByIdAssistantsErrors, PostApiServicesAssistantcollectionsByIdAssistantsResponses, PostApiServicesAssistantcollectionsByIdFollowData, PostApiServicesAssistantcollectionsByIdFollowErrors, PostApiServicesAssistantcollectionsByIdFollowResponses, PostApiServicesAssistantcollectionsData, PostApiServicesAssistantcollectionsErrors, PostApiServicesAssistantcollectionsResponses, PostApiServicesAssistantkindsData, PostApiServicesAssistantkindsErrors, PostApiServicesAssistantkindsResponses, PostApiServicesAssistantsByIdPublishData, PostApiServicesAssistantsByIdPublishErrors, PostApiServicesAssistantsByIdPublishResponses, PostApiServicesAssistantsByIdUnpublishData, PostApiServicesAssistantsByIdUnpublishErrors, PostApiServicesAssistantsByIdUnpublishResponses, PostApiServicesAssistantsData, PostApiServicesAssistantsErrors, PostApiServicesAssistantsResponses, PostApiServicesChatCompletionsData, PostApiServicesChatCompletionsErrors, PostApiServicesChatCompletionsResponse, PostApiServicesChatCompletionsResponses, PostApiServicesChatSessionsByIdArchiveData, PostApiServicesChatSessionsByIdArchiveErrors, PostApiServicesChatSessionsByIdArchiveResponses, PostApiServicesChatSessionsByIdUnarchiveData, PostApiServicesChatSessionsByIdUnarchiveErrors, PostApiServicesChatSessionsByIdUnarchiveResponses, PostApiServicesChatSessionsData, PostApiServicesChatSessionsErrors, PostApiServicesChatSessionsResponses } from './types.gen';
import { zDeleteApiServicesAssistantcollectionsByIdAssistantsByAssistantIdPath, zDeleteApiServicesAssistantcollectionsByIdAssistantsByAssistantIdResponse, zDeleteApiServicesAssistantcollectionsByIdFollowPath, zDeleteApiServicesAssistantcollectionsByIdFollowResponse, zDeleteApiServicesAssistantcollectionsByIdPath, zDeleteApiServicesAssistantcollectionsByIdResponse, zDeleteApiServicesAssistantkindsByIdPath, zDeleteApiServicesAssistantkindsByIdResponse, zDeleteApiServicesAssistantsByIdPath, zDeleteApiServicesAssistantsByIdResponse, zGetApiAuthCapabilitiesResponse, zGetApiAuthTokenResponse, zGetApiServicesAssistantcollectionsByIdAssistantsPath, zGetApiServicesAssistantcollectionsByIdAssistantsQuery, zGetApiServicesAssistantcollectionsByIdAssistantsResponse, zGetApiServicesAssistantcollectionsByIdPath, zGetApiServicesAssistantcollectionsByIdResponse, zGetApiServicesAssistantcollectionsQuery, zGetApiServicesAssistantcollectionsResponse, zGetApiServicesAssistantkindsByIdPath, zGetApiServicesAssistantkindsByIdResponse, zGetApiServicesAssistantkindsResponse, zGetApiServicesAssistantsByIdPath, zGetApiServicesAssistantsByIdResponse, zGetApiServicesAssistantsQuery, zGetApiServicesAssistantsResponse, zGetApiServicesChatSessionsByIdPath, zGetApiServicesChatSessionsByIdResponse, zGetApiServicesChatSessionsQuery, zGetApiServicesChatSessionsResponse, zPatchApiServicesAssistantcollectionsByIdBody, zPatchApiServicesAssistantcollectionsByIdPath, zPatchApiServicesAssistantcollectionsByIdResponse, zPatchApiServicesAssistantkindsByIdBody, zPatchApiServicesAssistantkindsByIdPath, zPatchApiServicesAssistantkindsByIdResponse, zPatchApiServicesAssistantsByIdBody, zPatchApiServicesAssistantsByIdPath, zPatchApiServicesAssistantsByIdResponse, zPatchApiServicesChatSessionsByIdBody, zPatchApiServicesChatSessionsByIdPath, zPatchApiServicesChatSessionsByIdResponse, zPostApiServicesAssistantcollectionsBody, zPostApiServicesAssistantcollectionsByIdAssistantsBody, zPostApiServicesAssistantcollectionsByIdAssistantsPath, zPostApiServicesAssistantcollectionsByIdAssistantsResponse, zPostApiServicesAssistantcollectionsByIdFollowPath, zPostApiServicesAssistantcollectionsByIdFollowResponse, zPostApiServicesAssistantcollectionsResponse, zPostApiServicesAssistantkindsBody, zPostApiServicesAssistantkindsResponse, zPostApiServicesAssistantsBody, zPostApiServicesAssistantsByIdPublishPath, zPostApiServicesAssistantsByIdPublishResponse, zPostApiServicesAssistantsByIdUnpublishPath, zPostApiServicesAssistantsByIdUnpublishResponse, zPostApiServicesAssistantsResponse, zPostApiServicesChatCompletionsBody, zPostApiServicesChatCompletionsResponse, zPostApiServicesChatSessionsBody, zPostApiServicesChatSessionsByIdArchivePath, zPostApiServicesChatSessionsByIdArchiveResponse, zPostApiServicesChatSessionsByIdUnarchivePath, zPostApiServicesChatSessionsByIdUnarchiveResponse, zPostApiServicesChatSessionsResponse } from './zod.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

/**
 * Delete assistant and all its versions
 */
export const deleteApiServicesAssistantsById = <ThrowOnError extends boolean = false>(options: Options<DeleteApiServicesAssistantsByIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiServicesAssistantsByIdResponses, DeleteApiServicesAssistantsByIdErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.optional(z.never()),
        path: zDeleteApiServicesAssistantsByIdPath,
        query: z.optional(z.never())
    }).parseAsync(data),
    responseValidator: async (data) => await zDeleteApiServicesAssistantsByIdResponse.parseAsync(data),
    url: '/api/services/assistants/{id}',
    ...options
});

/**
 * Get assistant by ID with latest version data
 */
export const getApiServicesAssistantsById = <ThrowOnError extends boolean = false>(options: Options<GetApiServicesAssistantsByIdData, ThrowOnError>) => (options.client ?? client).get<GetApiServicesAssistantsByIdResponses, GetApiServicesAssistantsByIdErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.optional(z.never()),
        path: zGetApiServicesAssistantsByIdPath,
        query: z.optional(z.never())
    }).parseAsync(data),
    responseValidator: async (data) => await zGetApiServicesAssistantsByIdResponse.parseAsync(data),
    url: '/api/services/assistants/{id}',
    ...options
});

/**
 * Update assistant (creates new version if systemPrompt or notes change)
 */
export const patchApiServicesAssistantsById = <ThrowOnError extends boolean = false>(options: Options<PatchApiServicesAssistantsByIdData, ThrowOnError>) => (options.client ?? client).patch<PatchApiServicesAssistantsByIdResponses, PatchApiServicesAssistantsByIdErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.optional(zPatchApiServicesAssistantsByIdBody),
        path: zPatchApiServicesAssistantsByIdPath,
        query: z.optional(z.never())
    }).parseAsync(data),
    responseValidator: async (data) => await zPatchApiServicesAssistantsByIdResponse.parseAsync(data),
    url: '/api/services/assistants/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List assistants with pagination and optional visibility filter
 */
export const getApiServicesAssistants = <ThrowOnError extends boolean = false>(options?: Options<GetApiServicesAssistantsData, ThrowOnError>) => (options?.client ?? client).get<GetApiServicesAssistantsResponses, GetApiServicesAssistantsErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.optional(z.never()),
        path: z.optional(z.never()),
        query: z.optional(zGetApiServicesAssistantsQuery)
    }).parseAsync(data),
    responseValidator: async (data) => await zGetApiServicesAssistantsResponse.parseAsync(data),
    url: '/api/services/assistants',
    ...options
});

/**
 * Create assistant with initial version
 */
export const postApiServicesAssistants = <ThrowOnError extends boolean = false>(options?: Options<PostApiServicesAssistantsData, ThrowOnError>) => (options?.client ?? client).post<PostApiServicesAssistantsResponses, PostApiServicesAssistantsErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.optional(zPostApiServicesAssistantsBody),
        path: z.optional(z.never()),
        query: z.optional(z.never())
    }).parseAsync(data),
    responseValidator: async (data) => await zPostApiServicesAssistantsResponse.parseAsync(data),
    url: '/api/services/assistants',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Publish an assistant (admin only)
 */
export const postApiServicesAssistantsByIdPublish = <ThrowOnError extends boolean = false>(options: Options<PostApiServicesAssistantsByIdPublishData, ThrowOnError>) => (options.client ?? client).post<PostApiServicesAssistantsByIdPublishResponses, PostApiServicesAssistantsByIdPublishErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.optional(z.never()),
        path: zPostApiServicesAssistantsByIdPublishPath,
        query: z.optional(z.never())
    }).parseAsync(data),
    responseValidator: async (data) => await zPostApiServicesAssistantsByIdPublishResponse.parseAsync(data),
    url: '/api/services/assistants/{id}/publish',
    ...options
});

/**
 * Unpublish an assistant (admin only)
 */
export const postApiServicesAssistantsByIdUnpublish = <ThrowOnError extends boolean = false>(options: Options<PostApiServicesAssistantsByIdUnpublishData, ThrowOnError>) => (options.client ?? client).post<PostApiServicesAssistantsByIdUnpublishResponses, PostApiServicesAssistantsByIdUnpublishErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.optional(z.never()),
        path: zPostApiServicesAssistantsByIdUnpublishPath,
        query: z.optional(z.never())
    }).parseAsync(data),
    responseValidator: async (data) => await zPostApiServicesAssistantsByIdUnpublishResponse.parseAsync(data),
    url: '/api/services/assistants/{id}/unpublish',
    ...options
});

/**
 * Get authentication token
 *
 * Returns the raw JWT token from the authenticated user's session. Useful for frontends that need access to the token stored in an HttpOnly cookie.
 */
export const getApiAuthToken = <ThrowOnError extends boolean = false>(options?: Options<GetApiAuthTokenData, ThrowOnError>) => (options?.client ?? client).get<GetApiAuthTokenResponses, GetApiAuthTokenErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.optional(z.never()),
        path: z.optional(z.never()),
        query: z.optional(z.never())
    }).parseAsync(data),
    responseValidator: async (data) => await zGetApiAuthTokenResponse.parseAsync(data),
    url: '/api/auth/token',
    ...options
});

/**
 * Get user capabilities for page-level access control
 *
 * Returns boolean flags indicating what high-level actions the current user can perform. Used by the frontend to show/hide navigation and admin features.
 */
export const getApiAuthCapabilities = <ThrowOnError extends boolean = false>(options?: Options<GetApiAuthCapabilitiesData, ThrowOnError>) => (options?.client ?? client).get<GetApiAuthCapabilitiesResponses, unknown, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.optional(z.never()),
        path: z.optional(z.never()),
        query: z.optional(z.never())
    }).parseAsync(data),
    responseValidator: async (data) => await zGetApiAuthCapabilitiesResponse.parseAsync(data),
    url: '/api/auth/capabilities',
    ...options
});

/**
 * List chat sessions
 */
export const getApiServicesChatSessions = <ThrowOnError extends boolean = false>(options?: Options<GetApiServicesChatSessionsData, ThrowOnError>) => (options?.client ?? client).get<GetApiServicesChatSessionsResponses, GetApiServicesChatSessionsErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.optional(z.never()),
        path: z.optional(z.never()),
        query: z.optional(zGetApiServicesChatSessionsQuery)
    }).parseAsync(data),
    responseValidator: async (data) => await zGetApiServicesChatSessionsResponse.parseAsync(data),
    url: '/api/services/chat/sessions',
    ...options
});

/**
 * Create chat session
 */
export const postApiServicesChatSessions = <ThrowOnError extends boolean = false>(options?: Options<PostApiServicesChatSessionsData, ThrowOnError>) => (options?.client ?? client).post<PostApiServicesChatSessionsResponses, PostApiServicesChatSessionsErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.optional(zPostApiServicesChatSessionsBody),
        path: z.optional(z.never()),
        query: z.optional(z.never())
    }).parseAsync(data),
    responseValidator: async (data) => await zPostApiServicesChatSessionsResponse.parseAsync(data),
    url: '/api/services/chat/sessions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Get chat session with messages
 */
export const getApiServicesChatSessionsById = <ThrowOnError extends boolean = false>(options: Options<GetApiServicesChatSessionsByIdData, ThrowOnError>) => (options.client ?? client).get<GetApiServicesChatSessionsByIdResponses, GetApiServicesChatSessionsByIdErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.optional(z.never()),
        path: zGetApiServicesChatSessionsByIdPath,
        query: z.optional(z.never())
    }).parseAsync(data),
    responseValidator: async (data) => await zGetApiServicesChatSessionsByIdResponse.parseAsync(data),
    url: '/api/services/chat/sessions/{id}',
    ...options
});

/**
 * Update chat session
 */
export const patchApiServicesChatSessionsById = <ThrowOnError extends boolean = false>(options: Options<PatchApiServicesChatSessionsByIdData, ThrowOnError>) => (options.client ?? client).patch<PatchApiServicesChatSessionsByIdResponses, PatchApiServicesChatSessionsByIdErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.optional(zPatchApiServicesChatSessionsByIdBody),
        path: zPatchApiServicesChatSessionsByIdPath,
        query: z.optional(z.never())
    }).parseAsync(data),
    responseValidator: async (data) => await zPatchApiServicesChatSessionsByIdResponse.parseAsync(data),
    url: '/api/services/chat/sessions/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Archive chat session
 */
export const postApiServicesChatSessionsByIdArchive = <ThrowOnError extends boolean = false>(options: Options<PostApiServicesChatSessionsByIdArchiveData, ThrowOnError>) => (options.client ?? client).post<PostApiServicesChatSessionsByIdArchiveResponses, PostApiServicesChatSessionsByIdArchiveErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.optional(z.never()),
        path: zPostApiServicesChatSessionsByIdArchivePath,
        query: z.optional(z.never())
    }).parseAsync(data),
    responseValidator: async (data) => await zPostApiServicesChatSessionsByIdArchiveResponse.parseAsync(data),
    url: '/api/services/chat/sessions/{id}/archive',
    ...options
});

/**
 * Unarchive chat session
 */
export const postApiServicesChatSessionsByIdUnarchive = <ThrowOnError extends boolean = false>(options: Options<PostApiServicesChatSessionsByIdUnarchiveData, ThrowOnError>) => (options.client ?? client).post<PostApiServicesChatSessionsByIdUnarchiveResponses, PostApiServicesChatSessionsByIdUnarchiveErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.optional(z.never()),
        path: zPostApiServicesChatSessionsByIdUnarchivePath,
        query: z.optional(z.never())
    }).parseAsync(data),
    responseValidator: async (data) => await zPostApiServicesChatSessionsByIdUnarchiveResponse.parseAsync(data),
    url: '/api/services/chat/sessions/{id}/unarchive',
    ...options
});

/**
 * Delete collection
 */
export const deleteApiServicesAssistantcollectionsById = <ThrowOnError extends boolean = false>(options: Options<DeleteApiServicesAssistantcollectionsByIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiServicesAssistantcollectionsByIdResponses, DeleteApiServicesAssistantcollectionsByIdErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.optional(z.never()),
        path: zDeleteApiServicesAssistantcollectionsByIdPath,
        query: z.optional(z.never())
    }).parseAsync(data),
    responseValidator: async (data) => await zDeleteApiServicesAssistantcollectionsByIdResponse.parseAsync(data),
    url: '/api/services/assistantcollections/{id}',
    ...options
});

/**
 * Get collection by ID
 */
export const getApiServicesAssistantcollectionsById = <ThrowOnError extends boolean = false>(options: Options<GetApiServicesAssistantcollectionsByIdData, ThrowOnError>) => (options.client ?? client).get<GetApiServicesAssistantcollectionsByIdResponses, GetApiServicesAssistantcollectionsByIdErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.optional(z.never()),
        path: zGetApiServicesAssistantcollectionsByIdPath,
        query: z.optional(z.never())
    }).parseAsync(data),
    responseValidator: async (data) => await zGetApiServicesAssistantcollectionsByIdResponse.parseAsync(data),
    url: '/api/services/assistantcollections/{id}',
    ...options
});

/**
 * Update collection
 */
export const patchApiServicesAssistantcollectionsById = <ThrowOnError extends boolean = false>(options: Options<PatchApiServicesAssistantcollectionsByIdData, ThrowOnError>) => (options.client ?? client).patch<PatchApiServicesAssistantcollectionsByIdResponses, PatchApiServicesAssistantcollectionsByIdErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.optional(zPatchApiServicesAssistantcollectionsByIdBody),
        path: zPatchApiServicesAssistantcollectionsByIdPath,
        query: z.optional(z.never())
    }).parseAsync(data),
    responseValidator: async (data) => await zPatchApiServicesAssistantcollectionsByIdResponse.parseAsync(data),
    url: '/api/services/assistantcollections/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List collections with pagination
 */
export const getApiServicesAssistantcollections = <ThrowOnError extends boolean = false>(options?: Options<GetApiServicesAssistantcollectionsData, ThrowOnError>) => (options?.client ?? client).get<GetApiServicesAssistantcollectionsResponses, GetApiServicesAssistantcollectionsErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.optional(z.never()),
        path: z.optional(z.never()),
        query: z.optional(zGetApiServicesAssistantcollectionsQuery)
    }).parseAsync(data),
    responseValidator: async (data) => await zGetApiServicesAssistantcollectionsResponse.parseAsync(data),
    url: '/api/services/assistantcollections',
    ...options
});

/**
 * Create collection
 */
export const postApiServicesAssistantcollections = <ThrowOnError extends boolean = false>(options?: Options<PostApiServicesAssistantcollectionsData, ThrowOnError>) => (options?.client ?? client).post<PostApiServicesAssistantcollectionsResponses, PostApiServicesAssistantcollectionsErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.optional(zPostApiServicesAssistantcollectionsBody),
        path: z.optional(z.never()),
        query: z.optional(z.never())
    }).parseAsync(data),
    responseValidator: async (data) => await zPostApiServicesAssistantcollectionsResponse.parseAsync(data),
    url: '/api/services/assistantcollections',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * List assistants in collection
 */
export const getApiServicesAssistantcollectionsByIdAssistants = <ThrowOnError extends boolean = false>(options: Options<GetApiServicesAssistantcollectionsByIdAssistantsData, ThrowOnError>) => (options.client ?? client).get<GetApiServicesAssistantcollectionsByIdAssistantsResponses, GetApiServicesAssistantcollectionsByIdAssistantsErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.optional(z.never()),
        path: zGetApiServicesAssistantcollectionsByIdAssistantsPath,
        query: z.optional(zGetApiServicesAssistantcollectionsByIdAssistantsQuery)
    }).parseAsync(data),
    responseValidator: async (data) => await zGetApiServicesAssistantcollectionsByIdAssistantsResponse.parseAsync(data),
    url: '/api/services/assistantcollections/{id}/assistants',
    ...options
});

/**
 * Add assistants to collection
 */
export const postApiServicesAssistantcollectionsByIdAssistants = <ThrowOnError extends boolean = false>(options: Options<PostApiServicesAssistantcollectionsByIdAssistantsData, ThrowOnError>) => (options.client ?? client).post<PostApiServicesAssistantcollectionsByIdAssistantsResponses, PostApiServicesAssistantcollectionsByIdAssistantsErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.optional(zPostApiServicesAssistantcollectionsByIdAssistantsBody),
        path: zPostApiServicesAssistantcollectionsByIdAssistantsPath,
        query: z.optional(z.never())
    }).parseAsync(data),
    responseValidator: async (data) => await zPostApiServicesAssistantcollectionsByIdAssistantsResponse.parseAsync(data),
    url: '/api/services/assistantcollections/{id}/assistants',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Remove assistant from collection
 */
export const deleteApiServicesAssistantcollectionsByIdAssistantsByAssistantId = <ThrowOnError extends boolean = false>(options: Options<DeleteApiServicesAssistantcollectionsByIdAssistantsByAssistantIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiServicesAssistantcollectionsByIdAssistantsByAssistantIdResponses, DeleteApiServicesAssistantcollectionsByIdAssistantsByAssistantIdErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.optional(z.never()),
        path: zDeleteApiServicesAssistantcollectionsByIdAssistantsByAssistantIdPath,
        query: z.optional(z.never())
    }).parseAsync(data),
    responseValidator: async (data) => await zDeleteApiServicesAssistantcollectionsByIdAssistantsByAssistantIdResponse.parseAsync(data),
    url: '/api/services/assistantcollections/{id}/assistants/{assistantId}',
    ...options
});

/**
 * Unfollow a collection
 */
export const deleteApiServicesAssistantcollectionsByIdFollow = <ThrowOnError extends boolean = false>(options: Options<DeleteApiServicesAssistantcollectionsByIdFollowData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiServicesAssistantcollectionsByIdFollowResponses, DeleteApiServicesAssistantcollectionsByIdFollowErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.optional(z.never()),
        path: zDeleteApiServicesAssistantcollectionsByIdFollowPath,
        query: z.optional(z.never())
    }).parseAsync(data),
    responseValidator: async (data) => await zDeleteApiServicesAssistantcollectionsByIdFollowResponse.parseAsync(data),
    url: '/api/services/assistantcollections/{id}/follow',
    ...options
});

/**
 * Follow a collection
 */
export const postApiServicesAssistantcollectionsByIdFollow = <ThrowOnError extends boolean = false>(options: Options<PostApiServicesAssistantcollectionsByIdFollowData, ThrowOnError>) => (options.client ?? client).post<PostApiServicesAssistantcollectionsByIdFollowResponses, PostApiServicesAssistantcollectionsByIdFollowErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.optional(z.never()),
        path: zPostApiServicesAssistantcollectionsByIdFollowPath,
        query: z.optional(z.never())
    }).parseAsync(data),
    responseValidator: async (data) => await zPostApiServicesAssistantcollectionsByIdFollowResponse.parseAsync(data),
    url: '/api/services/assistantcollections/{id}/follow',
    ...options
});

/**
 * Delete an assistant kind
 */
export const deleteApiServicesAssistantkindsById = <ThrowOnError extends boolean = false>(options: Options<DeleteApiServicesAssistantkindsByIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiServicesAssistantkindsByIdResponses, DeleteApiServicesAssistantkindsByIdErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.optional(z.never()),
        path: zDeleteApiServicesAssistantkindsByIdPath,
        query: z.optional(z.never())
    }).parseAsync(data),
    responseValidator: async (data) => await zDeleteApiServicesAssistantkindsByIdResponse.parseAsync(data),
    url: '/api/services/assistantkinds/{id}',
    ...options
});

/**
 * Get assistant kind by ID
 */
export const getApiServicesAssistantkindsById = <ThrowOnError extends boolean = false>(options: Options<GetApiServicesAssistantkindsByIdData, ThrowOnError>) => (options.client ?? client).get<GetApiServicesAssistantkindsByIdResponses, GetApiServicesAssistantkindsByIdErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.optional(z.never()),
        path: zGetApiServicesAssistantkindsByIdPath,
        query: z.optional(z.never())
    }).parseAsync(data),
    responseValidator: async (data) => await zGetApiServicesAssistantkindsByIdResponse.parseAsync(data),
    url: '/api/services/assistantkinds/{id}',
    ...options
});

/**
 * Update an assistant kind
 */
export const patchApiServicesAssistantkindsById = <ThrowOnError extends boolean = false>(options: Options<PatchApiServicesAssistantkindsByIdData, ThrowOnError>) => (options.client ?? client).patch<PatchApiServicesAssistantkindsByIdResponses, PatchApiServicesAssistantkindsByIdErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.optional(zPatchApiServicesAssistantkindsByIdBody),
        path: zPatchApiServicesAssistantkindsByIdPath,
        query: z.optional(z.never())
    }).parseAsync(data),
    responseValidator: async (data) => await zPatchApiServicesAssistantkindsByIdResponse.parseAsync(data),
    url: '/api/services/assistantkinds/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List all assistant kinds
 */
export const getApiServicesAssistantkinds = <ThrowOnError extends boolean = false>(options?: Options<GetApiServicesAssistantkindsData, ThrowOnError>) => (options?.client ?? client).get<GetApiServicesAssistantkindsResponses, unknown, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.optional(z.never()),
        path: z.optional(z.never()),
        query: z.optional(z.never())
    }).parseAsync(data),
    responseValidator: async (data) => await zGetApiServicesAssistantkindsResponse.parseAsync(data),
    url: '/api/services/assistantkinds',
    ...options
});

/**
 * Create a new assistant kind
 */
export const postApiServicesAssistantkinds = <ThrowOnError extends boolean = false>(options?: Options<PostApiServicesAssistantkindsData, ThrowOnError>) => (options?.client ?? client).post<PostApiServicesAssistantkindsResponses, PostApiServicesAssistantkindsErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.optional(zPostApiServicesAssistantkindsBody),
        path: z.optional(z.never()),
        query: z.optional(z.never())
    }).parseAsync(data),
    responseValidator: async (data) => await zPostApiServicesAssistantkindsResponse.parseAsync(data),
    url: '/api/services/assistantkinds',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Create streaming chat completion
 *
 * Creates a streaming chat completion using the specified assistant's system prompt.
 */
export const postApiServicesChatCompletions = <ThrowOnError extends boolean = false>(options: Options<PostApiServicesChatCompletionsData, ThrowOnError, PostApiServicesChatCompletionsResponse>) => (options.client ?? client).sse.post<PostApiServicesChatCompletionsResponses, PostApiServicesChatCompletionsErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: zPostApiServicesChatCompletionsBody,
        path: z.optional(z.never()),
        query: z.optional(z.never())
    }).parseAsync(data),
    responseValidator: async (data) => await zPostApiServicesChatCompletionsResponse.parseAsync(data),
    url: '/api/services/chat/completions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
